<template>
    <div class="base-pills-like-tab-bar">
        <div class="base-pills-like-tab-bar__item"
            @click="selectOption(option)"
            v-for="option in options"
            :key="option.label"
            :class="{ 'base-pills-like-tab-bar__item_active': selectedOption === option }">
            {{ option.label }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'BasePillsLikeTabBar',
    data() {
        return {
            selectedOption: this.options[0]
        }
    },
    model: {
        prop: 'modelValue',
        event: 'change'
    },
    props: {
        /**
         * option format: {
         *   label: String,
         * }
         * */
        options: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        modelValue: {
            handler(newVal) {
                this.selectedOption = this.options.find(option => option === newVal) || this.options[0]
            },
            immediate: true
        }
    },
    methods: {
        selectOption(option) {
            this.selectedOption = option
            this.$emit('change', option)
        }
    }
}
</script>

<style lang="scss" scoped>
.base-pills-like-tab-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px;
    height: 40px;
    border-radius: 20px;
    box-sizing: border-box;
    background-color: $rfx-light-steel;

    &__item {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 16px;
        border-radius: 18px;
        height: 32px;
        box-sizing: border-box;
        background-color: transparent;
        color: $rfx-text-dark-high-contrast;
        cursor: pointer;
        flex: 1;
        user-select: none;

        &:hover:not(.base-pills-like-tab-bar__item_active) {
            background-color: $rfx-medium-steel;
        }

        &_active {
            background-color: $rfx-text-dark-high-contrast;
            color: white;
        }
    }
}

</style>